import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import TimeAward from './../../../../commons/components/Award/TimeAward'
import ROUTERS from '../../../../commons/constans/router';
import BtnGoToAwardRegister from './BtnGoToAwardRegister';
import Slider from "../../../../commons/components/Slider";


import { ReactComponent as ImgRankingLeft } from '../../../../assets/images/img_ranking_left.svg';
import { ReactComponent as ImgRankingRight } from '../../../../assets/images/img_ranking_right.svg';
import { ReactComponent as ImgRiftbox01 } from '../../../../assets/images/img_giftbox01.svg';
import { ReactComponent as ImgGiftbox02 } from '../../../../assets/images/img_giftbox02.svg';
import { ReactComponent as IconNextBtnPurple } from '../../../../assets/images/icon_next_btn_Purple.svg';

type props = {};

const AwardsProgressComponent = ({award = {}, entry = {}}: props) => {
  const navigate = useNavigate();

  const goToAwardVote = () => {
    navigate(ROUTERS.AWARD_VOTING)
  }

  // const prizes = award.prizes ? [award.prizes[0], award.prizes[1], award.prizes[2]] : []
  return (
    <div className="tab-awards-progress">
      <div className="intro-awards">
        <div className="time-awards justify-content-between">
          {/* <img src="/images/img_ranking_left.svg" /> */}
          <ImgRankingLeft />
          {award.ended_at && <TimeAward award={award} />}
          {/* <img src="/images/img_ranking_right.svg" /> */}
          <ImgRankingRight />
        </div>
        <div className="content-img-awards">
          {/* <img className="img-box1" src="/images/img_giftbox01.svg" /> */}
          <ImgRiftbox01 />
          {/* <img className="img-box2" src="/images/img_giftbox02.svg" /> */}
          <ImgGiftbox02 />
        </div>
        {award.prizes && award.prizes.length ? <Slider
          pagination={true}
          autoplay={true}
          delay={3000}
          loop={true}
          // initialSlide={1}
          classSlider="swiper-award-prize"
        >
          {award.prizes?.map((prize) => (
            <div className="main-prize-awards" key={prize.id}>
              <div className="main-prize-awards__text">
                <h3>{prize.title}</h3>
                <p>{prize.description}</p>
              </div>
              {prize?.image_url && 
                <Fragment>
                  <img className="img-phone-rw" src={prize?.image_url?.thumbnail} />
                </Fragment>
              }
              {prize.name && 
                <button className="btn-kids-phone-awards">
                  <label>{prize.name}</label>
                </button>
              }
            </div>
          ))}
        </Slider> : null}
        <div className="content-awards-btn">
          <BtnGoToAwardRegister show={!entry.id} />
          <button className="btn btn-rounded  btn-primary btn-light" onClick={goToAwardVote}>
            <label>투표 하러가기</label>
            {/* <img src="/images/icon_next_btn_Purple.svg" /> */}
            <IconNextBtnPurple />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AwardsProgressComponent;
